import { PDF_HIDDEN_BRIGHT, PDF_LETTET_BLANK, PDF_SUSPEND_BRIGHT } from 'features/PDF/constants/style';
import { ApproveSelect, ConfirmSelect } from '../ApproveSelect/approveSelect';
import { useGetRole } from 'components/formfields/Privilege/components/editForm';
import { PRIVILEGE_ROLE, PRIVILEGE_STATUS } from 'components/formfields/constants/privilege';
import { useSelector } from 'react-redux';
import { selectUserInfo } from 'features/Auth/authSlice';
import '../../style.scss';
import SelectMenuColor from '../SelectMenuColor/SelectMenuColor';
import dayjs from 'dayjs';

const MenuRow = ({
  record,
  styles,
  index,
  isSelected,
  onApprove,
  onConfirm,
  confirmUserId,
  revisionDate,
  onChangeMenuName,
  isAllowedEdit,
  status,
}: any) => {
  const role = useGetRole();
  const menuRecord = record.value;
  const user = useSelector(selectUserInfo);
  const curUserId = user?.employee_cd;
  const isSuspend = dayjs(new Date(revisionDate)).startOf('date') > dayjs(new Date(record.suspendDate)).startOf('date');
  return (
    <div
      style={{ ...styles.row } as any}
      key={index}
      // onClick={(e) => {
      //   e.stopPropagation();
      // }}
    >
      <ApproveSelect
        onApprove={onApprove}
        record={record}
        isSelected={isSelected}
        isSuspend={isSuspend}
        disabled={role === PRIVILEGE_ROLE.NORMAL || status !== PRIVILEGE_STATUS.PENDING_APPROVAL}
      />
      <ConfirmSelect
        onConfirm={onConfirm}
        record={record}
        isSelected={isSelected}
        disabled={
          (curUserId === confirmUserId && role === PRIVILEGE_ROLE.NORMAL) ||
          status !== PRIVILEGE_STATUS.PENDING_CONFIRMATION
        }
        isSuspend={isSuspend}
      />

      {Object.keys(menuRecord).map((key, colIndex) => {
        return (
          // VALUE
          <div
            style={{
              ...styles.col,
              ...styles.colValue,
              ...{
                ...menuRecord[key]?.style,
                width: menuRecord[key].style?.width + '%',
              },
              ...(colIndex === 0 ? styles.colNameValue : {}),
              ...(isSuspend ? { filter: `brightness(${PDF_SUSPEND_BRIGHT}%)` } : {}),
              ...(record.isHidden ? { filter: `brightness(${PDF_HIDDEN_BRIGHT}%)` } : {}),
              position: 'relative',
            }}
            key={colIndex + 'menuCol'}
          >
            <SelectMenuColor isSelected={isSelected} />
            <div
              style={{
                marginLeft: colIndex === 0 ? PDF_LETTET_BLANK * menuRecord[key]?.blank || 0 : 0,
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              {colIndex === 0 ? (
                <input
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  className="chart_text"
                  type="text"
                  value={menuRecord[key]?.value}
                  onChange={(e: any) => onChangeMenuName(e, record, key)}
                  disabled={!isAllowedEdit}
                  style={{
                    border: 'none',
                    width: '100%',
                    height: '100%',
                  }}
                />
              ) : (
                menuRecord[key].value
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export { MenuRow };
